<div class="modal-content">
  <div class="modal-header">
    <h6 class="modal-title" id="vcenter">{{ 'dataform.implementation.file_upload.error_header' | translate }}</h6>
    <a (click)="modal.close('')" type="button" class="close">×</a>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <p-table    [value]="data"
                    [paginator]="true"
                    [rows]="10"
                    [totalRecords]="data.length" >
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th class="text-center">{{ 'dataform.implementation.tabs.detail_information.table.line' | translate }}</th>
              <th class="text-center">{{ 'dataform.implementation.tabs.detail_information.table.value' | translate }}</th>
              <th class="text-center">{{ 'dataform.implementation.tabs.detail_information.table.header' | translate }}</th>
              <th class="text-center">{{ 'dataform.implementation.tabs.detail_information.table.description' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              <td class="text-center">{{ rowData.lineNumber }}</td>
              <td class="text-center">{{ rowData.value }}</td>
              <td class="text-center">{{ rowData.headerValue }}</td>
              <td class="text-center">{{ rowData.description }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
